import FormModule from "components/Modules/Documents/FormModule"
import {
  createOrUpdateFirestoreDocument,
  deleteFirestoreDocument,
  getFirestoreDocument,
} from "helpers/Firestore"

const CityNotificationsForm = ({ opened }) => {
  return (
    <FormModule
      form={{
        title: "Notifications",
        fields: [
          {
            ID: "1",
            Name: "title",
            Label: "Title",
            Type: "Text",
            Required: true,
            Prompt: "Title is required",
            ReadOnly: !!opened,
          },
          {
            ID: "2",
            Name: "body",
            Label: "Body",
            FieldType: "textarea",
            Type: "Text",
            ReadOnly: !!opened,
            Required: true,
            Prompt: "Body is required",
          },
          {
            ID: "3",
            Type: "Multiple Choice Dropdown",
            Name: "UserTypes",
            Label: "User Types",
            GetSelectionOptions: async (values, { firebaseUID }) => {
              return [
                {
                  ID: "Citizen",
                  Name: "Citizen",
                },
                {
                  ID: "Tourist",
                  Name: "Tourist",
                },
                {
                  ID: "Student",
                  Name: "Student",
                },
                {
                  ID: "Nomad",
                  Name: "Nomad",
                },
              ]
            },
            ReadOnly: !!opened,
            Required: true,
            Prompt: "User Types is required",
          },
          {
            ID: "4",
            Name: "SendInAppNotification",
            Label: "Send In-App Notification",
            Type: "Checkbox Buttons",
            GetSelectionOptions: async (values, { firebaseUID }) => {
              return [
                {
                  ID: "Yes",
                  Name: "Yes",
                },
              ]
            },
            ReadOnly: !!opened,
            Required: true,
          },
          {
            ID: "5",
            Name: "SendPushNotification",
            Label: "Send Push Notification",
            Type: "Checkbox Buttons",
            GetSelectionOptions: async (values, { firebaseUID }) => {
              return [
                {
                  ID: "Yes",
                  Name: "Yes",
                },
              ]
            },
            ReadOnly: !!opened,
            Required: true,
          },
        ],
        fieldsToTranslate: ["title", "body"],
        getDefaultValues: async ({ firebaseUID }) => {
          if (!opened)
            return {
              SendInAppNotification: ["Yes"],
              SendPushNotification: ["Yes"],
            }

          const data = await getFirestoreDocument({
            path: `City/Cities/DataBase/${firebaseUID}/Modules/notifications/DataBase/${opened}`,
          })

          return {
            ...data,
            UserTypes: data.UserTypes?.map(userType => ({
              ID: userType,
              Name: userType,
            })),
            SendInAppNotification: data.SendInAppNotification ? ["Yes"] : [],
            SendPushNotification: data.SendPushNotification ? ["Yes"] : [],
          }
        },
        onSubmit: async (values, { firebaseUID }) => {
          return await createOrUpdateFirestoreDocument({
            path: `City/Cities/DataBase/${firebaseUID}/Modules/notifications/DataBase`,
            values: {
              ...values,
              UserTypes: values.UserTypes.map(userType => userType.ID),
              SendInAppNotification: values.SendInAppNotification.length > 0,
              SendPushNotification: values.SendPushNotification.length > 0,
            },
          })
        },
        onDelete: async ({ firebaseUID }) => {
          return await deleteFirestoreDocument({
            path: `City/Cities/DataBase/${firebaseUID}/Modules/notifications/DataBase/${opened}`,
          })
        },
      }}
      ID={opened}
    />
  )
}

export default CityNotificationsForm
